import { Button } from '@treams/treams-ui';

import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import SaveStatus from './SaveStatus';

const SaveLineContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	flex-direction: row;
	margin-top: 8px;
	gap: 5px;
`;

export default function SaveLine({
	onSave,
	onDiscard,
	changed,
	saving,
	dirty,
	autosave = false,
}: {
	onSave: () => void;
	onDiscard: () => void;
	changed: boolean;
	saving: boolean;
	dirty: boolean;
	autosave?: boolean;
}) {
	const { t } = useTranslation();
	return (
		<SaveLineContainer>
			{<SaveStatus dirty={dirty} changed={changed} saving={saving || (autosave && dirty)} />}
			{!autosave && (
				<>
					{dirty && !saving && (
						<Button
							type="transparent"
							disabled={saving || !changed}
							title={t('conversations.module.answer.discard')}
							onClick={onDiscard}
							small
						/>
					)}
					<Button
						small
						onClick={onSave}
						disabled={saving}
						title={t('conversations.module.answer.save')}
					/>
				</>
			)}
		</SaveLineContainer>
	);
}
